<script setup>
import { computed, onMounted } from 'vue';
import { useCamerasStore } from '@/store/cameras';
import { imagePayloadHandler } from '@/composables/artifactHelper'

const cameraStore = useCamerasStore()

const props = defineProps({
  artifactId: { type: String, default: '' },
  payload: { type: Object, default: null },
  isDownloaded: { type: Boolean, default: false },
  artifactData: { type: Object, default: () => ({}) },
  fullScreen: { type: Boolean, default: false },
  isDownloading: { type: Boolean, default: false },
  isMiniArtifact: { type: Boolean, default: false },
})

const stillFrame = computed(() => {
  if (!cameraStore.currentStillFrames[props.artifactData.data.cameraId]) return null
  if (!cameraStore.currentStillFrames[props.artifactData.data.cameraId][200]) return null
  return cameraStore.currentStillFrames[props.artifactData.data.cameraId][200].frame
})

const imagePayload = computed(() => imagePayloadHandler(props.payload))

onMounted(async () => {
  if (props.artifactData.data.cameraId)
    await cameraStore.loadCurrentStillFrame(props.artifactData.data.cameraId, { resizeY: 200 })
})
</script>

<template>
  <v-card
    variant="flat"
    elevation="0"
    style="height: 100%; max-height: 100%; width: auto;"
  >
    <v-img
      v-if="!isDownloaded"
      :src="stillFrame"
      :max-height="fullScreen ? '100%' : '40vh'"
      height="100%"
      :cover="props.isMiniArtifact"
      gradient="to top right, rgba(0,0,0,0.6), rgba(0,0,0,.3)"
    >
      <v-container class="justify-center align-center fill-height">
        <v-chip prepend-icon="mdi-alert">
          {{ $t("artifact.not_downloaded_yet") }}
        </v-chip>
      </v-container>
    </v-img>
    <v-img
      v-else
      height="100%"
      :cover="props.isMiniArtifact && !fullScreen"
      :src="imagePayload"
    />
  </v-card>
</template>

<style scoped>

</style>
